import { ClientSideOnly } from '@/components/clientSideOnly';
import * as charts from '@/components/dashboard';
import DashBoardLayout from '@/components/dashboard/DashboardLayout';
import { ArticleContainer } from '@/routes/resource/key/components/articleContainer';
import { ArticleTextContainer } from '@/routes/resource/key/components/articleTextContainer';
import { useTaxonKeyLoaderData } from '.';
import { useIsFamilyOrAbove, useNextMajorRank } from '@/hooks/taxonomyRankHooks';

export default function Metrics() {
  const { data } = useTaxonKeyLoaderData();
  const taxon = data?.taxonInfo;

  const isFamilyOrAbove = useIsFamilyOrAbove(taxon?.taxonRank ?? '');
  const nextMajorRank = useNextMajorRank(taxon?.taxonRank ?? 'GENUS');

  const predicate = {
    type: 'equals',
    key: 'taxonKey',
    value: taxon?.taxonID,
    checklistKey: taxon?.datasetKey,
  };

  if (!taxon) return null;
  return (
    <ArticleContainer className="g-bg-slate-100 g-pt-4">
      <ArticleTextContainer className="g-max-w-screen-xl">
        <ClientSideOnly>
          {isFamilyOrAbove && (
            <DashBoardLayout>
              {/* <charts.OccurrenceSummary predicate={predicate} className="g-mb-4" /> */}

              <charts.Taxa
                predicate={predicate}
                className="g-mb-4"
                defaultRank={nextMajorRank?.toLowerCase()}
              />

              <charts.DataQuality predicate={predicate} className="g-mb-4" />
              <charts.Months predicate={predicate} className="g-mb-4" />
              <charts.Datasets predicate={predicate} className="g-mb-4" />
              <charts.Country predicate={predicate} className="g-mb-4" />
              <charts.BasisOfRecord predicate={predicate} className="g-mb-4" />
              <charts.Synonyms predicate={predicate} className="g-mb-4" />
            </DashBoardLayout>
          )}
          {!isFamilyOrAbove && (
            <DashBoardLayout>
              {/* <charts.OccurrenceSummary predicate={predicate} className="g-mb-4" /> */}

              <charts.DataQuality predicate={predicate} className="g-mb-4" />
              <charts.Months predicate={predicate} className="g-mb-4" />
              <charts.Datasets predicate={predicate} className="g-mb-4" />
              <charts.Country predicate={predicate} className="g-mb-4" />
              <charts.BasisOfRecord predicate={predicate} className="g-mb-4" />
              <charts.Synonyms predicate={predicate} className="g-mb-4" />
            </DashBoardLayout>
          )}
        </ClientSideOnly>
      </ArticleTextContainer>
    </ArticleContainer>
  );
}
